import { useState, useEffect } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import EventIcon from '@material-ui/icons/Event'
import ReceiptIcon from "@material-ui/icons/Receipt"
import HomePage from "../../Home"
import { Container } from "@material-ui/core"
import TReservas from "../TRservas"
import TReservasAutorizadas from "../TReservasAuth/idnex"
import { useDispatch } from "react-redux"
import { obtenerReservasAction } from "../../../ducks/reservasDuck"
import { obtenerReservasAuthAction } from "../../../ducks/reservasAuthDuck"
import FiltradoReservas from "../FiltradoReservas"
import FiltradoReservasAutorizadas from "../FiltrarReservasAutorizadas"
import TReservasExpiradas from "../TReservasExpiradas"
import { obtenerReservasExpiradasAction } from "../../../ducks/reservasExpiradasDuck"
import FiltradoReservasExpiradas from "../FiltradoReservasExpiradas"
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    )
}

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
const VReservas = () => {
    const [value, setValue] = useState(0)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerReservasAction())
        dispatch(obtenerReservasAuthAction())
        dispatch(obtenerReservasExpiradasAction())
    }, [dispatch])
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Reservas</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="secondary">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                aria-label="scrollable force tabs example"
                            >
                                <Tab
                                    label="Pendientes"
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label="Expiradas"
                                    icon={<ReceiptIcon />}
                                    {...a11yProps(1)}
                                />
                                <Tab
                                    label="Autorizados"
                                    icon={<ReceiptIcon />}
                                    {...a11yProps(2)}
                                />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <FiltradoReservas />
                            <TReservas />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <FiltradoReservasExpiradas />
                            <TReservasExpiradas />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <FiltradoReservasAutorizadas />
                            <TReservasAutorizadas />
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VReservas